import classes from './styles.module.scss';

function DashboardSectionHeader({ children, styles = {} }) {
  return (
    <div className={classes.dashboard_layout_header} style={{ ...styles }}>
      {children}
    </div>
  );
}

export default DashboardSectionHeader;
